// client/src/components/TiptapEditor/MenuBar/HistoryGroup.js
import React from "react";

export const HistoryGroup = ({ editor }) => {
  return (
    <>
      <button
        onClick={() => editor.chain().focus().undo().run()}
        disabled={!editor.can().undo()}
      >
        Undo
      </button>
      <button
        type="button"
        onClick={() => editor.chain().focus().redo().run()}
        disabled={!editor.can().redo()}
      >
        Redo
      </button>
    </>
  );
};
